import React from 'react';
import { useInView } from 'react-intersection-observer';
import { HiShieldCheck, HiGlobeAlt, HiLightningBolt, HiChip } from 'react-icons/hi';
import { useLanguage } from '../../i18n/LanguageContext';
import './Stats.css';

const Stats = () => {
  const { t } = useLanguage();
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });
  const icons = [<HiShieldCheck />, <HiGlobeAlt />, <HiChip />, <HiLightningBolt />];
  const pillars = t('stats.pillars').map((pillar, index) => ({
    ...pillar,
    icon: icons[index],
  }));

  return (
    <section className="stats" id="why" ref={ref}>
      <div className="stats__container">
        <div className="stats__header">
          <span className="section-eyebrow" style={{ color: 'var(--cyan)' }}>
            {t('stats.eyebrow')}
          </span>
          <h2 className="section-title">{t('stats.title')}</h2>
          <p className="stats__subtitle">
            {t('stats.subtitle')}
          </p>
        </div>

        <div className={`stats__grid ${inView ? 'stats__grid--visible' : ''}`}>
          {pillars.map((pillar, index) => (
            <div
              key={pillar.title}
              className="stats__card"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="stats__card-header">
                <div className="stats__card-icon">{pillar.icon}</div>
                <span className="stats__card-tag">{pillar.tag}</span>
              </div>

              <div className="stats__card-body">
                <h3 className="stats__card-title">{pillar.title}</h3>
                <p className="stats__card-description">{pillar.description}</p>
                <ul className="stats__card-list">
                  {pillar.points.map((point) => (
                    <li key={point} className="stats__card-list-item">
                      {point}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
